import { normalizeNumber } from 'utils'

export const createTimeHandler =
  (fieldName: string, maxValue: number, onChange: (field: string) => (value: string) => void) =>
  (value: string | number) => {
    const handler = onChange(fieldName)
    const numberValue = Number(value)

    if (numberValue > maxValue || numberValue < 0 || isNaN(numberValue)) {
      return
    }

    if (!value) {
      handler('')
      return
    }

    const val = normalizeNumber(numberValue)
    handler(val)
  }
